import {defineMessages} from 'react-intl';
import {chevronDown, chevronUp} from '@sail/icons/react/Icon';
import {HeaderButton, Placement} from './HeaderButton';
import {useWidgetControls, useWidgetVisibility} from '../useWidget';
import {useAnalytics} from '../../AnalyticsProvider';

const messages = defineMessages({
  open: {
    id: 'conversations_ui.widget.header.openButton.label',
    description:
      'Label used for the header button that takes the widget from a minimized state to an open state.',
    defaultMessage: 'Show',
  },
  minimize: {
    id: 'conversations_ui.widget.header.minimizeButton.label',
    description:
      'Label used for the header button that takes the widget from an open state to a minimized state.',
    defaultMessage: 'Hide',
  },
});

type Props = {
  disabled?: boolean;
};

export function ToggleMinimizeButton({disabled = false}: Props) {
  const {visibility} = useWidgetVisibility();
  const {toggle} = useWidgetControls();
  const analytics = useAnalytics();

  let label;
  let icon;
  let placement: Placement;

  if (visibility === 'open') {
    label = messages.minimize;
    icon = chevronDown;
    placement = 'bottom left';
  } else {
    label = messages.open;
    icon = chevronUp;
    placement = 'left';
  }

  return (
    <HeaderButton
      testId="conversations-widget-header-toggle-button"
      icon={icon}
      label={label}
      onPress={() => {
        analytics.action('toggle_minimize_button_clicked');
        toggle();
      }}
      tooltipPlacement={placement}
      disabled={disabled}
    />
  );
}
